export const getRandomColor = (minColorValue = 50) => {
  let red, green, blue;

  do {
    red = Math.floor(Math.random() * 256);
    green = Math.floor(Math.random() * 256);
    blue = Math.floor(Math.random() * 256);
  } while (red + green + blue > 3 * 255 - 3 * minColorValue); // Check if the color is close to white

  const color = `rgb(${red},${green},${blue})`;

  return color;
};
